import { makeId } from "./uuid"

export const generateKey = (pre) => {
  return `${pre}_${new Date().getTime()}_${makeId(5)}`
}
